export default "__VITE_ASSET__SeaoItLs__"